import { Box, Grid } from "@mui/material";
import { useMemo, useRef } from "react";
import { ActionButton } from "../Button";
import { useLanguageContext } from "../../contexts/LanguageContext";
import DefaultConstants from "../../data/Constants";
import Dialog, { IDefaultDialogProps } from "../Dialog";
import AttachmentCard from '../AttachmentCard';
import FileHelper from "../../helpers/FileHelper";
import Empty from "../Empty";
import AttachmentTypeSelectorPopover from "../Popover/AttachmentTypeSelectorPopover";
import usePopover from "../../hooks/usePopover";


interface IAddAttachmentsDialogProps extends IDefaultDialogProps {
    attachments: File[];
    handleUpdateAttachments: (attachments: File[]) => void;
}


const AddAttachmentsDialog: React.FunctionComponent<IAddAttachmentsDialogProps> = ({
    open,
    handleClose,
    attachments,
    handleUpdateAttachments
}) => {
    const { translate } = useLanguageContext();

    const attachmentTypeSelectorPopover = usePopover();
    const buttonAddAttachmentRef = useRef<HTMLButtonElement | null>(null);


    const dialogActions = useMemo(() => {
        return [
            <ActionButton action='close' onClick={handleClose} />,
            
            <Box ref={buttonAddAttachmentRef}>
                <ActionButton action='add' onClick={() => attachmentTypeSelectorPopover.handleOpen()} />
            </Box>
        ];
        // eslint-disable-next-line
    }, [translate]);


    const attachmentContent = useMemo(() => {
        if (attachments.length === 0) {
            return <Grid item xs={12}>
                <Empty text="noAttachmentsFound" />
            </Grid>;
        }
    
        return attachments.map((a, index) => {
            return <Grid item lg={3} md={4} sm={6} xs={6} key={index}>
                <AttachmentCard
                    link={FileHelper.CreateUrl(a)}
                    name={a.name}
                    hoverAction='remove'
                    onClick={() => {
                        attachments.splice(index, 1);
                        handleUpdateAttachments(attachments);
                    }}
                />
            </Grid>;
        });
        // eslint-disable-next-line
    }, [attachments.length]);


    return <>
        <Dialog
            open={open}
            handleClose={handleClose}
            title={translate('attachments')}
            dialogActions={dialogActions}
            className='dialogactions-spacebetween overflow-inherit'
            absolute={true}
            dividers={true}
        >
            <Grid 
                container 
                columnSpacing={DefaultConstants.gridColumnSpacing} 
                rowSpacing={DefaultConstants.gridRowSpacing}
                paddingY={2}
            >
                {attachmentContent}
            </Grid>
        </Dialog>

        <AttachmentTypeSelectorPopover
            open={attachmentTypeSelectorPopover.open} 
            handleClose={() => attachmentTypeSelectorPopover.handleClose()} 
            anchorEl={buttonAddAttachmentRef.current}
            acceptImage={true}
            acceptVideo={true}
            capture="environment"
            handleUpdateAttachments={files => {
                handleUpdateAttachments(attachments.concat(files));
                attachmentTypeSelectorPopover.handleClose();
            }} 
        />
    </>;
}

export default AddAttachmentsDialog;